import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { Role } from '../model/Role';

export const loginActivateGuard = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const router = inject(Router);
  const authService = inject(AuthenticationService);

  const user = authService.getCurrentUser();
  if (user) {
    if (user.userType === Role.ADMINISTRATOR || user.userType === Role.GROUP) {
      router.navigateByUrl('account-selection');
    } else {
      router.navigateByUrl('report');
    }
    return false;
  }

  return true;
};
